import React from "react";
import Icons from "../../../../config/images";
import './aboutImage.css';

const AboutImage = () => {
  return (
    <div className="about-section">
      <img
        src={Icons.aboutUs}
        alt="About Us"
        className="about-page-main-image"
      />
      <p className="about-section-title-style">Empowering Innovation, Delivering Excellence</p>
      <p className="about-section-sub-title-style">
        We are a passionate team of designers, developers, and strategists,
        committed to creating impactful digital solutions that drive success for
        our clients.
      </p>
    </div>
  );
};

export default AboutImage;
